import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Style } from '../domain/styles/stylesDto';

interface TargetCollection {
  name: string;
  customer: string;
}

export interface BatchModeState {
  isEnabled: boolean;
  selectedStyles: Style[];
  targetCollection: TargetCollection;
  baseMockupId: string;
}

const initialState: BatchModeState = {
  isEnabled: false,
  selectedStyles: [],
  targetCollection: {
    name: '',
    customer: '',
  },
  baseMockupId: '',
};

export const batchModeSlice = createSlice({
  name: 'batchMode',
  initialState,
  reducers: {
    enableBatchMode(state) {
      state.isEnabled = true;
    },
    disableBatchMode(state) {
      state.isEnabled = false;
      state.selectedStyles = [];
      state.targetCollection = {
        name: '',
        customer: '',
      };
    },
    setSelectedStyles(state, action: PayloadAction<any[]>) {
      state.selectedStyles = action.payload;
    },
    setTargetCollection(state, action: PayloadAction<TargetCollection>) {
      state.targetCollection = action.payload;
    },
    setBaseMockupId(state, action: PayloadAction<string>) {
      state.baseMockupId = action.payload;
    },
  },
});

export const {
  enableBatchMode,
  disableBatchMode,
  setSelectedStyles,
  setTargetCollection,
  setBaseMockupId,
} = batchModeSlice.actions;

export const batchModeReducer = batchModeSlice.reducer;
